import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, ChevronUp } from 'lucide-react';

export const TableOfContents = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  const sections = [
    { id: 'what-is-dishashool', title: 'दिशाशूल क्या होता है?' },
    { id: 'dishashool-chart', title: 'दिशा शूल चार्ट' },
    { id: 'dishashool-shlok', title: 'दिशा शूल श्लोक' },
    { id: 'dishashool-meaning', title: 'दिशाशूल का अर्थ' },
    { id: 'dishashool-origin', title: 'दिशाशूल की उत्पत्ति और महत्व' },
    { id: 'dishashool-determination', title: 'दिशाशूल का निर्धारण' },
    { id: 'directions-and-lords', title: 'दिशाएं और उनके स्वामी' },
    { id: 'remedies', title: 'दिशाशूल से बचने के उपाय' },
    { id: 'astrological-remedies', title: 'दिशाशूल से बचने के ज्योतिष संबंधी उपाय' },
    { id: 'importance', title: 'दिशाशूल का महत्व' },
    { id: 'misconceptions', title: 'दिशाशूल की आम भ्रांतियां' },
    { id: 'conclusion', title: 'निष्कर्ष' }
  ];

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsExpanded(true);
    }
  };

  return (
    <nav className="sticky top-4 bg-white/90 backdrop-blur-sm rounded-lg p-4 shadow-sm mb-8">
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="w-full flex items-center justify-between text-lg font-semibold text-purple-900 mb-2"
      >
        <span>विषय-सूची</span>
        {isExpanded ? (
          <ChevronUp className="h-5 w-5" />
        ) : (
          <ChevronDown className="h-5 w-5" />
        )}
      </button>

      <AnimatePresence>
        {isExpanded && (
          <motion.ul
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.2 }}
            className="space-y-2 overflow-hidden"
          >
            {sections.map((section) => (
              <motion.li
                key={section.id}
                whileHover={{ x: 4 }}
                className="cursor-pointer"
              >
                <button
                  onClick={() => scrollToSection(section.id)}
                  className="text-purple-600 hover:text-purple-800 transition-colors text-left w-full"
                >
                  {section.title}
                </button>
              </motion.li>
            ))}
          </motion.ul>
        )}
      </AnimatePresence>
    </nav>
  );
};